/* Parans FAQs — left-rail category switcher.
   Clicking a category in the left rail shows its content panel on the right.
   Accessible (tablist/tab/tabpanel), keyboard arrows, scoped per section,
   re-inits on shopify:section:load. */
(function () {
  function initFaqs(root) {
    if (!root || root.dataset.faqsInit === 'true') return;
    root.dataset.faqsInit = 'true';

    var tabs = Array.prototype.slice.call(
      root.querySelectorAll('.parans-faqs__cat')
    );
    var panels = Array.prototype.slice.call(
      root.querySelectorAll('.parans-faqs__panel')
    );
    if (!tabs.length || !panels.length) return;

    function activate(index, focus) {
      tabs.forEach(function (tab, i) {
        var selected = i === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.setAttribute('tabindex', selected ? '0' : '-1');
        if (selected && focus) tab.focus();
      });
      panels.forEach(function (panel, i) {
        var selected = i === index;
        panel.classList.toggle('is-active', selected);
        if (selected) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activate(i, false);
      });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
          next = (i + 1) % tabs.length;
        } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
          next = (i - 1 + tabs.length) % tabs.length;
        } else if (e.key === 'Home') {
          next = 0;
        } else if (e.key === 'End') {
          next = tabs.length - 1;
        }
        if (next !== null) {
          e.preventDefault();
          activate(next, true);
        }
      });
    });

    // First active by default (or whichever already has aria-selected="true").
    var initial = tabs.findIndex(function (t) {
      return t.getAttribute('aria-selected') === 'true';
    });
    activate(initial >= 0 ? initial : 0, false);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('.parans-faqs');
    Array.prototype.forEach.call(roots, initFaqs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
